"use client";

// "Is this the admin console?", for the site-wide marketing tags.
//
// None of them belong in /admin: those pages are internal, noindex and behind
// SSO, so every tag there measures staff doing their job and reports it as
// visitor activity — sessions in Clarity, pageviews in GA and HubSpot, a
// company identified as its own visitor in Apollo.
//
// The check has to happen on the CLIENT. The admin console has no root layout
// of its own — it shares the site's, which is why Header and Footer return
// null on /admin rather than being absent — so a server component rendered
// from that layout cannot tell which route it is in. The only server-side way
// to find out is to read a request header, and that would opt every page on
// the site out of static rendering to answer a question about one subtree.
//
// So the tags do what Header already does, and for the same reason.
import { usePathname } from "next/navigation";

export function useIsAdminRoute(): boolean {
  const pathname = usePathname();
  // Deliberately a prefix, not an exact match: it also covers /admin-login,
  // which is no more a marketing page than the console behind it.
  return Boolean(pathname?.startsWith("/admin"));
}
